import { FC } from 'react';

import { Board, Council } from 'types';
import { BoardEntityTypes } from 'types/Board';
import RecentBoardsSectionRow from './RecentBoardsSectionRow';
import RecentBoardsSectionListHeader from './RecentBoardsSectionListHeader';

type RecentBoardsSectionListProps = {
  boards: Council[] | Board[];
  boardType: BoardEntityTypes;
  isAdmin: boolean;
  onRemoveBoard: (index: number) => void; // eslint-disable-line no-unused-vars
};

const RecentBoardsSectionList: FC<RecentBoardsSectionListProps> = ({
  boards,
  boardType,
  isAdmin,
  onRemoveBoard,
}) => (
  <table className="table">
    <RecentBoardsSectionListHeader boardType={boardType} isAdmin={isAdmin} />

    <tbody>
      {boards.map((board: Council | Board, index: number) => (
        <RecentBoardsSectionRow
          key={board._id}
          board={board}
          boardType={boardType}
          index={index}
          isAdmin={isAdmin}
          onRemoveBoard={onRemoveBoard}
        />
      ))}
    </tbody>
  </table>
);

export default RecentBoardsSectionList;
